import type { TranslationKey } from "@msuite/utils/locales";

/** Every weekday's name, Monday-first — indexed by `BusinessHoursDay.weekday`. */
export const WEEKDAY_TRANSLATION_KEYS: Array<TranslationKey> = [
	"dates.monday",
	"dates.tuesday",
	"dates.wednesday",
	"dates.thursday",
	"dates.friday",
	"dates.saturday",
	"dates.sunday",
];
